<template>
  <div ref="modaldes" class="modal" tabindex="-1" role="dialog" id="modal-modalmovimientos">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center"><b>Detalle de Movimientos</b></h5>
        </div>

        <div class="modal-body py-0">
          <p class="text-center text-danger">
            <b>{{ msg }}</b>
          </p>
          <div class="text-center">
            <div style="display: inline-block;" v-show="loading" class="loader"></div>
          </div>
          <p class="mt-0">
            <b>Estudiante: </b>
            <span> {{ estudiante.nombres }} {{ estudiante.pri_apellido }} {{ estudiante.seg_apellido }} </span>
          </p>

          <div class="table-responsive">
            <table class="table table-striped table-condensed table-hover">
              <thead>
                <tr>
                  <th>Concepto</th>
                  <th>Nro. cuota</th>
                  <th>Movimiento</th>
                  <th>Monto</th>
                  <th>Pagado</th>
                  <th>Fecha Prevista</th>
                  <th>Fecha de Movimiento</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(m, ind) in movimientos" :key="ind">
                  <td>{{ m.concepto_pago }}</td>
                  <td>{{ m.nro_cuota }}</td>
                  <td>{{ m.detalle }}</td>
                  <td>{{ m.monto_programado }} <span>Bs.</span></td>
                  <td>{{ m.monto_realizado }} <span>Bs.</span></td>
                  <td>{{ parsefecha(m.fecha_programado) }}</td>
                  <td>{{ parsefecha(m.fecha_realizada) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-azul white--text" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        msg: '',
        loading: false,
        movimientos: [],
        estudiante: {},
      };
    },
    watch: {},
    components: {},
    methods: {
      open(ins) {
        this.movimientos = [];
        this.estudiante = ins.estudiante;
        //window.console.log(ins);
        window.$('#modal-modalmovimientos').modal('show');
        this.getmovimientos(ins);
      },
      getmovimientos(ins) {
        this.loading = true;
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${ins.id}/plan-pago/movimientos`;
        xaxios
          .get(url)
          .then(({ data }) => {
            vue.movimientos = data.data;
            vue.loading = false;
          })
          .catch((e) => {
            window.console.error(e);
          });
      },
      parsefecha(f) {
        if (!f) return '';
        f = f.trim();
        let fs = f.split(' ');
        let fs2 = fs[0].split('-');
        let fs3 = '';
        if (fs.length > 1) fs3 = fs[1];
        return `${fs2[2]}/${fs2[1]}/${fs2[0]} ${fs3}`;
      },
    },
    mounted() {
      var vue = this;
      window.$('#modal-modalmovimientos').on('hide', function() {
        vue.msg = '';
      });
    },
  };
</script>
